import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../../utils';
import { UserPlus } from 'lucide-react';

export default function EmployeeHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Data Pegawai</h1>
        <p className="text-gray-500 mt-1">Kelola seluruh data pegawai perusahaan</p>
      </div>
      <Link to={createPageUrl('EmployeeForm')}>
        <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md font-medium flex items-center transition-all duration-300">
          <UserPlus className="w-4 h-4 mr-2" />
          Tambah Pegawai
        </button>
      </Link>
    </div>
  );
}
